
import React  from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {findDOMNode} from 'react-dom'
import ReactTooltip from 'react-tooltip'
// import $ from 'jquery'
// $('.clipbord-svg').on('click', function () {
        
//     // $(this).attr('title', 'NEW_TITLE')
//     // .tooltip('fixTitle')
//     // .tooltip('show');
//     // $(this).tooltip('hide')
//     //   .attr('data-original-title', "copied")
//     //   .tooltip('fixTitle')
//     //   .tooltip('show');
//     let codes = $(this).data("codes")
//     let codeArea = $('.clipbordArea[data-codes="' + codes + '"')
//     $(codeArea).val(allcodes[codes])
//     $(codeArea).select()
//     try{
      
//     document.execCommand("copy");
//       $(this).attr("title","Copied!").tooltip("_fixTitle").tooltip("show").attr("title","Copy to clipboard").tooltip("_fixTitle");
//     }catch(e){
//       $(this).attr("title","not Copied!").tooltip("_fixTitle").tooltip("show").attr("title","Copy to clipboard").tooltip("_fixTitle");
//     }
    
    
//   })
export default class CopyClip extends React.Component{

    constructor(props){
        super(props)
        this.state={
            copied:false,
            tooltipVal:'Copy to clipbord',
            clickables:false,
            clickablesVal:''
        }
    }
    componentDidUpdate(){
        ReactTooltip.show(findDOMNode(this.refs.codes))
        // $('.clipbord-svg,.playsvg').tooltip({ boundary: 'window' })
        // $(".clipbord-svg").attr("title","Copied!").tooltip("_fixTitle").tooltip("show").attr("title","Copy to clipboard").tooltip("_fixTitle");
        // console.log('updatessssss')
    }

    // copy(){
    //     let codes = $(this).data("codes")
    // let codeArea = $('.clipbordArea[data-codes="' + codes + '"')
    // $(codeArea).val(allcodes[codes])
    // document.getElementById("myTextarea").value = "Fifth Avenue, New York City"; 
    // $(codeArea).select()
    // document.getElementById("myTextarea").select(); 
    // try{
      
    // document.execCommand("copy");
    // $(this).attr("title","Copied!").tooltip("_fixTitle").tooltip("show").attr("title","Copy to clipboard").tooltip("_fixTitle");
    // }catch(e){
    //   $(this).attr("title","not Copied!").tooltip("_fixTitle").tooltip("show").attr("title","Copy to clipboard").tooltip("_fixTitle");
    // }
    
    
    // }
    render(){
        return(
            <>
            <CopyToClipboard text={this.props.value}
                onCopy={() => this.setState({copied: true})}>
                <svg className="clipbord-svg" data-codes="1" id="i-clipboard"
                title="" data-original-title="Copy to clipboard"
                
            ref='foo'
                data-tip={this.state.tooltipVal}
                // data-for='copyTool'
                // data-event={this.state.clickablesVal}
                // data-tip={this.state.tooltipVal}
                // refs='codes'
                onClick={
                    ()=>{
                        
                    ReactTooltip.hide(findDOMNode(this.refs.foo))
                        this.setState({
                            tooltipVal:"copied" 
                        },function () {
                            let self=this
                            setTimeout(function () {
                                ReactTooltip.show(findDOMNode(self.refs.foo))
                                setTimeout(function () {
                                    self.setState({ 
                                    tooltipVal:'Copy to clipbord'
                                    })
                                    ReactTooltip.hide(findDOMNode(self.refs.foo))
                                    
                                },1000)
                            },500)
                        })
                    }
                }
                // onClick={
                //     ()=>{
                //         console.log('copy')
                //         this.setState({
                //             tooltipVal:'Copied'
                //         },function () {
                //             this.setState({
                //                 clickable:true,
                //                 clickablesVal:'click'
                //             })
                //             // ReactTooltip.hide(findDOMNode(this.refs.codes))
                //         //     ReactTooltip.rebuild()
                //         // ReactTooltip.show(findDOMNode(this.refs.codes))
                //         })
                        
                //         // ReactTooltip.show(findDOMNode(this.refs.codes))
                //         // ReactTooltip.rebuild()
                //     }
                // }
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                    fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                    strokeWidth="2">
                    <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                </svg>
            </CopyToClipboard>
            <ReactTooltip 
            // id="copyTool"
             effect='solid'
            // getContent={() =><div>{this.state.tooltipVal}</div> }
//  delayHide={500}
//  delayShow={500}
//  delayUpdate={500}
 border={true}
//  eventOff={this.state.clickables}
//  clickable={this.state.clickables}
 type={'light'}/>
            {/* <ReactTooltip id='sadFace' type='warning' effect='solid'>
  <span>Show sad face</span>
</ReactTooltip> */}
             {/* <svg className="clipbord-svg" data-codes="1" id="i-clipboard"
                title="" data-original-title="Copy to clipboard"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                    fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                    strokeWidth="2">
                    <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                </svg>
                <textarea className="clipbordArea" data-codes="1" cols="auto" rows="auto"></textarea> */}
                                
            </>
        )
    }
}